<div class="tertiary-content-header">
  <h4 *ngIf="!isOnboarding">
    <span class="font-gray">Users</span>&nbsp;/&nbsp;<span class="font-600">{{ title }}</span>
  </h4>

  <h4 *ngIf="isOnboarding">
    <span class="font-gray">
      <span *ngIf="!userId">Users&nbsp;/&nbsp;Create new user</span>
      <span *ngIf="userId">Users&nbsp;/&nbsp;{{ user?.firstName }} {{ user?.lastName }}</span>
    </span>
  </h4>
</div>

<div *ngIf="!isProcessing" class="create-user pl-0 pt-3 pr-2 pb-2">
  <!-- Start user create form -->
  <div class="ui-g p-0 mt-2 mb-4 pb-3">
    <div class="ui-g-8 p-0">
      <div class="ui-g-6 p-0 pr-4">
        <app-dropdown id="create-user-type" listId="create-user-type-list" theme="primary" label="User Type*"
          styleClass="pl-0" styleClassSelectedView="pl-0" [isDropdownIconVisible]="true" styleClassLabel="left-0"
          placeholder="User Type*" [disabled]="isSuperUser || isSupportUser" [floatingLabel]="true" [fontSize]="14"
          [value]="user.role" [options]="getAvailableRoles()" (appChange)="selectRole($event)"
          (appSelect)="selectRole($event)"></app-dropdown>
        <span class="font-error">{{ starterTierTechUserWarningMsg }}</span>
      </div>

      <div class="ui-g-2 p-0 pr-4">
        <div *ngIf="user?.role?.value !== 'owner' && adminRoles.includes(role)" [hidden]="isCurrentUser">
          <app-switch-pill position="end" [label]="user?.isInActive ? 'Inactive' : 'Active'"
            [isActive]="!user?.isInActive" [disabled]="isSupportUser || (ordinaryAdmin && isMultiLocationEnabled)"
            (appChange)="handleSwitchChange('user-switch', $event)"></app-switch-pill>
        </div>
      </div>

      <div [hidden]="company?.tierType === 'starter' || company?.tierType?.toLowerCase() === 'essentials'"
        class="ui-g-4 p-0" *ngIf="isWorkAsTechEnabled && adminRoles.includes(user?.role?.value)">
        <div class="flex-start-center">
          <app-switch-pill position="end" [label]="'Work as Technician'" [isActive]="user.isWorkAsTechEnabled"
            [disabled]="defaultUser.isWorkAsTechEnabled"
            (appChange)="handlTechSettingChange('isWorkAsTechEnabled', $event)"></app-switch-pill>
          <i class="fa fa-info-circle font-gray-35"
            pTooltip="When the 'Work for technician' flag is turned on, the user will be logged out for changes to come into affect."
            tooltipPosition="top"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g p-0 mt-2 mb-4 pb-3">
    <div class="ui-g-8 p-0">
      <div class="ui-g-6 p-0 pr-4">
        <app-input id="create-user-fname" placeholder="First name*" styleClassLabel="left-0" styleClass="pl-0"
          styleClassInput="pl-0" [isInvalid]="errors.firstName" [errorMessage]="errors.firstName" [floatingLabel]="true"
          [value]="user.firstName" (appFocus)="handleFocus('firstName')" (appBlur)="handleBlur('firstName')"
          (appChange)="handleChange('firstName', $event)"
          [disabled]="isSupportUser && !isSupportAdminAccount"></app-input>
      </div>

      <div class="ui-g-6 p-0">
        <app-input id="create-user-lname" placeholder="Last name*" styleClassLabel="left-0" styleClass="pl-0"
          styleClassInput="pl-0" [isInvalid]="errors.lastName" [errorMessage]="errors.lastName" [floatingLabel]="true"
          [value]="user.lastName" (appFocus)="handleFocus('lastName')" (appBlur)="handleBlur('lastName')"
          (appChange)="handleChange('lastName', $event)"
          [disabled]="isSupportUser && !isSupportAdminAccount"></app-input>
      </div>
    </div>
  </div>

  <div class="ui-g p-0 mt-2 mb-4 pb-3">
    <div class="ui-g-8 p-0">
      <div class="ui-g-6 p-0 pr-4">
        <app-input id="create-user-email" placeholder="Email*" styleClassLabel="left-0" styleClass="pl-0"
          styleClassInput="pl-0" [isInvalid]="errors.email" [errorMessage]="errors.email" [floatingLabel]="true"
          [value]="user.email" (appFocus)="handleFocus('email')" (appBlur)="handleBlur('email')"
          (appChange)="handleChange('email', $event)" [disabled]="isSupportUser && !isSupportAdminAccount">
        </app-input>
      </div>

      <div class="ui-g-6 p-0">
        <app-input id="create-user-mobile" placeholder="Mobile*" styleClassLabel="left-0" styleClass="pl-0"
          styleClassInput="pl-0" [isInvalid]="errors.phone" [errorMessage]="errors.phone" mask="(000) 000-0000"
          [floatingLabel]="true" [value]="user.phone" (appFocus)="handleFocus('phone')" (appBlur)="handleBlur('phone')"
          (appChange)="handleChange('phone', $event)" [disabled]="isSupportUser && !isSupportAdminAccount"></app-input>
      </div>
    </div>
  </div>

  <div class="ui-g p-0 mt-2 mb-4 pb-3" *ngIf="isTechnicianSelected() || user.isWorkAsTechEnabled">
    <div class="ui-g-8 p-0">
      <div class="ui-g-6 p-0 pr-4">
        <app-input id="create-user-rate" placeholder="Hourly rate*" mask="0*.99" styleClassLabel="left-0"
          styleClass="pl-0" styleClassInput="pl-0" [isInvalid]="errors.rate" [errorMessage]="errors.rate"
          [floatingLabel]="true" [value]="user.rate" (appFocus)="handleFocus('rate')"
          (appChange)="handleChange('rate', $event)" [disabled]="isSupportUser && !isSupportAdminAccount"></app-input>
      </div>

      <div class="ui-g-6 p-0">
        <app-input id="create-user-initials" placeholder="Initials*" minLength="1" maxLength="2"
          styleClassLabel="left-0" styleClass="pl-0" styleClassInput="pl-0" [isInvalid]="errors.initials"
          [errorMessage]="errors.initials" [floatingLabel]="true" [value]="user.initials"
          (appFocus)="handleFocus('initials')" (appKeyUp)="handleBlur('initials')"
          (appChange)="handleChange('initials', $event)"
          [disabled]="isSupportUser && !isSupportAdminAccount"></app-input>
      </div>
    </div>
  </div>

  <div class="ui-g p-0 mt-2 mb-4 pb-3"
    *ngIf="isCommissionPlanEnabled || user?.isWorkAsTechEnabled || isTechnicianSelected()">
    <div class="ui-g-8 p-0">
      <div class="ui-g-6 p-0 pr-4 position-relative" *ngIf="!isTechnicianSelected() && isCommissionPlanEnabled">
        <app-auto-complete id="commission-plan-advisor" listId="commission-plan-advisor-dropdown-list"
          label="Commission plan ({{ user?.role?.name }})" placeholder="Commission plan ({{ user?.role?.name }})"
          field="name" scrollHeight="180px" theme="primary" styleClassInput="pr-5" [textTruncate]="true"
          [floatingLabel]="true" [maxLength]="75" [hasFutureSelectionField]="false" [closeOnSelection]="true"
          [isDropdownIconVisible]="!user?.commissionAdvisor?.name" [selectTextOnFocus]="true"
          [hasStaticUnassignedFiled]="false" [suggestions]="commissionPlanSuggestions" [listItemFontSize]="14"
          [fontSize]="14" [value]="user?.commissionAdvisor?.name || ''"
          (appSelect)="handleChange('commissionAdvisor', $event)"
          (appCompletedMethod)="handleSearchCommission('nontechnician', $event)"
          (appClickInput)="handleClearSearch('nontechnician')" (appClear)="handleClearSearch('nontechnician')">
          <ng-template let-item appTemplate="item">
            <div class="tag-item flex-between-center">
              <div>
                <span>{{ item?.name }}</span>
              </div>

              <div class="tag-item-action flex-end-center"></div>
            </div>
          </ng-template>
        </app-auto-complete>

        <div class="remove-icon admin" *ngIf="user?.commissionAdvisor?.name">
          <i class="fal fa-times p-1 pointer font-gray" (click)="openConfirmationDialog('commissionAdvisor')"></i>
        </div>
      </div>

      <div class="ui-g-6 p-0 position-relative"
        [ngClass]="{ 'pr-4': isTechnicianSelected() && isCommissionPlanEnabled }"
        *ngIf="isCommissionPlanEnabled && (user?.isWorkAsTechEnabled || isTechnicianSelected())">
        <app-auto-complete id="commission-plan-tech" listId="commission-plan-tech-dropdown-list"
          label="Commission plan (Technician)" placeholder="Commission plan (Technician)" field="name"
          scrollHeight="180px" theme="primary" styleClassInput="pr-5" [textTruncate]="true" [floatingLabel]="true"
          [maxLength]="75" [hasFutureSelectionField]="false" [closeOnSelection]="true"
          [isDropdownIconVisible]="!user?.commissionTech?.name" [hasStaticUnassignedFiled]="false"
          [suggestions]="commissionPlanForServiceMetric" [listItemFontSize]="14" [fontSize]="14"
          [value]="user?.commissionTech?.name || ''" (appSelect)="handleChange('commissionTech', $event)"
          (appCompletedMethod)="handleSearchCommission('technician', $event)"
          (appClear)="handleClearSearch('technician')">
          <ng-template let-item appTemplate="item">
            <div class="tag-item flex-between-center">
              <div>
                <span>{{ item?.name }}</span>
              </div>

              <div class="tag-item-action flex-end-center"></div>
            </div>
          </ng-template>
        </app-auto-complete>

        <div class="remove-icon tech" *ngIf="user?.commissionTech?.name">
          <i class="fal fa-times p-1 pointer font-gray" (click)="openConfirmationDialog('commissionTech')"></i>
        </div>
      </div>

      <div class="ui-g-6 p-0" *ngIf="isTechnicianSelected() || user.isWorkAsTechEnabled"
        [ngClass]="registerNumberGridClass()">
        <app-input id="create-tech-register" placeholder="Registration number" styleClassLabel="left-0"
          styleClass="pl-0" styleClassInput="pl-0" [floatingLabel]="true" [value]="user.registrationNumber"
          (appFocus)="handleFocus('registrationNumber')" (appBlur)="handleBlur('registrationNumber')"
          (appChange)="handleChange('registrationNumber', $event)"></app-input>
      </div>
    </div>
  </div>
  <!-- End user create form -->

  <div class="ui-g p-0">
    <div class="ui-g-8 p-0">
      <div class="ui-g-12 p-0">
        <div class="user-container mt-4">
          <div class="user-accordion">
            <p-accordion styleClass="estimate-accordion reverse-chevron-icon" expandIcon="pi pi-fw pi-chevron-down"
              collapseIcon="pi pi-fw pi-chevron-right" *ngIf="!isTechnicianSelected()">
              <p-accordionTab [selected]="user?.role?.value === 'serviceWriter'">
                <p-header>
                  <h2 class="mb-0 font-16 font-bold font-secondary-800">Permissions</h2>
                </p-header>

                <!-- Replace default-state class with disabled-state -->
                <div class="default-state user-privilege">
                  <div *ngFor="let privilege of privileges; let pIndex = index">
                    <span class="user-permission-row" *ngIf="!['assign-unassign-service'].includes(privilege.title)"
                      [ngClass]="{'flex-wrap':privilege?.title == 'restrict-ip-access'}">
                      <div class="ui-g-11 p-0 user-permission-navition">
                        <i class="fal" [ngClass]="privilege.iconClass"></i>
                        <span> {{ privilege.label }} </span>
                        <i class="fa fa-info-circle font14 font-gray-35 pointer"
                          *ngIf="privilege?.title == 'commission-plan'" pTooltip="Allow user to:
                          1. Create Commission Plans
                          2. Assign Commission plans to Users
                          3. Review / edit Commissions on ROs
                          4. View Commission Reports
                          5. Set default commissionable state for catalog items" tooltipPosition="top"
                          tooltipStyleClass="labor-rate-tooltip"></i>
                      </div>
                      <div *ngIf="['commission-plan', 'customer-mandatory-field-edit'].includes(privilege?.title)"
                        class="ui-g-1 p-0 flex-end-start user-permission-navition">
                        <span class="badge new-privilage">New</span>
                      </div>

                      <div class="user-permission-status">
                        <app-switch-pill 
                          [disabled]="!privilege.configurable"
                          [pxId]="'permission-toggle-' + privilege.title"
                          [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                          (appChange)="handlePrivilegeChange(privilege, $event)"></app-switch-pill>
                      </div>

                      <!-- ----- add restricted ips ------  -->
                      <ng-container
                        *ngIf="privilege?.title === 'restrict-ip-access' && selectedPrivilege[privilege?.title]?.permitted">
                        <ng-container *ngTemplateOutlet="restrictIpAccessTemplate"></ng-container>
                      </ng-container>

                      <!-- ----- add restricted ips ------  -->
                    </span>

                    <span class="user-permission-row" *ngIf="['assign-unassign-service'].includes(privilege.title)">
                      <div class="ui-g-3">
                        <div class="user-permission-navition">
                          <i class="fal" [ngClass]="privilege.iconClass"></i>
                          <span> Self assignment </span>
                        </div>
                      </div>

                      <div class="ui-g-9">
                        <div class="user-permission-status">
                          <app-dropdown placeholder="" theme="border" class="width-100p" field="name"
                            styleClassSelectedView="p-6p" scrollHeight="198px" [options]="assignTechOptions"
                            [isDropdownIconVisible]="true" [fullyControlled]="true"
                            [value]="{ name: selectedPrivilege[privilege?.title]?.label }"
                            (appSelect)="onSelectSelfAssign($event, privilege)">
                          </app-dropdown>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div *ngIf="adminRoles.includes(user?.role?.value)"
                    class="user-permission-row invoice-code-privilege">
                    <p-accordion class="width-100p inner-accordion-wrapper"
                      styleClass="width-100p estimate-accordion reverse-chevron-icon"
                      expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-right">
                      <p-accordionTab [selected]="user?.role?.value === 'serviceWriter'">
                        <p-header>
                          <h2 class="mb-0 font-16 font-bold font-secondary-800">RO</h2>
                        </p-header>

                        <!-- Replace default-state class with disabled-state -->
                        <div *ngFor="let privilege of orderPrivilege; let pIndex = index"
                          [hidden]="!privilege?.isVisible" class="default-state accordion-level-2">
                          <div class="user-permission-row">
                            <div class="user-permission-navition">
                              <i [ngClass]="privilege?.iconClass"></i>
                              <span>{{ privilege?.label }}</span>
                              <span *ngIf="['revert-invoices'].includes(privilege.title)">
                                <i class="fa fa-info-circle font-gray-35 ml-2" [pTooltip]="
                                    'Users with this privilege will be able to unlock locked invoices by changing their order status from Invoice to Estimate thereby making such orders editable for all users. </br> </br>  Users without this privilege will not be able to unlock locked invoices; they will however be able to request this change from a user with this privilege.'
                                  " tooltipPosition="top" tooltipStyleClass="labor-rate-tooltip" [escape]="false">
                                </i>
                              </span>
                            </div>

                            <div class="user-permission-status">
                              <app-switch-pill [disabled]="!privilege?.configurable"
                                [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                                (appChange)="handlePrivilegeChange(privilege, $event)">
                              </app-switch-pill>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <!-- customer privileges -->
                  <div
                    *ngIf="adminRoles.includes(user?.role?.value) && (isChargeAccountEnabled && (isSupportAdminAccount || isArAccountManagement))"
                    class="user-permission-row invoice-code-privilege">
                    <p-accordion class="width-100p inner-accordion-wrapper"
                      styleClass="width-100p estimate-accordion reverse-chevron-icon"
                      expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-right">
                      <p-accordionTab [selected]="user?.role?.value === 'serviceWriter'">
                        <p-header>
                          <h2 class="mb-0 font-16 font-bold font-secondary-800">Customer</h2>
                        </p-header>

                        <!-- Replace default-state class with disabled-state -->
                        <div *ngFor="let privilege of customerPrivilege; let pIndex = index"
                          [hidden]="!privilege?.isVisible" class="default-state accordion-level-2">
                          <div class="user-permission-row">
                            <div class="user-permission-navition">
                              <i [ngClass]="privilege?.iconClass"></i>
                              <span>{{ privilege?.label }}</span>
                              <span>
                                <i class="fa fa-info-circle font-gray-35 ml-2" tooltipPosition="top" [escape]="false"
                                  tooltipStyleClass="ticket-tooltip modifier pinned" [pTooltip]="arAccountIconTooltip">
                                </i>
                              </span>
                            </div>

                            <div class="user-permission-status">
                              <app-switch-pill [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                                (appChange)="handlePrivilegeChange(privilege, $event)">
                              </app-switch-pill>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <!-- customer privileges end-->

                  <!-- pricing management privileges -->
                  <div
                    *ngIf="adminRoles.includes(user?.role?.value) && (isPricingManagementEnable && (isSupportAdminAccount || isPricingMatricesManagement))"
                    class="user-permission-row invoice-code-privilege">
                    <p-accordion class="width-100p inner-accordion-wrapper"
                      styleClass="width-100p estimate-accordion reverse-chevron-icon"
                      expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-right">
                      <p-accordionTab [selected]="user?.role?.value === 'serviceWriter'">
                        <p-header>
                          <h2 class="mb-0 font-16 font-bold font-secondary-800">Pricing</h2>
                        </p-header>

                        <!-- Replace default-state class with disabled-state -->
                        <div *ngFor="let privilege of pricingPrivilege; let pIndex = index"
                          [hidden]="!privilege?.isVisible" class="default-state accordion-level-2">
                          <div class="user-permission-row">
                            <div class="user-permission-navition">
                              <i [ngClass]="privilege?.iconClass"></i>
                              <span>{{ privilege?.label }}</span>
                              <span>
                                <i class="fa fa-info-circle font-gray-35 ml-2" tooltipPosition="top" [escape]="false"
                                  tooltipStyleClass="ticket-tooltip modifier pinned" [pTooltip]="pricingIconTooltip">
                                </i>
                              </span>
                            </div>

                            <div class="user-permission-status">
                              <app-switch-pill [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                                (appChange)="handlePrivilegeChange(privilege, $event)">
                              </app-switch-pill>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <!-- pricing management privileges end-->

                  <!---- catalog privileges -->
                  <div *ngIf="isNewItemCategoriesEnable || isInventoryManagementEnabled"
                    class="user-permission-row invoice-code-privilege">
                    <p-accordion class="width-100p inner-accordion-wrapper"
                      styleClass="width-100p estimate-accordion reverse-chevron-icon"
                      expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-right">
                      <p-accordionTab>
                        <p-header>
                          <h2 class="mb-0 font-16 font-bold font-secondary-800">
                            {{isInventoryManagementEnabled ? 'Catalog and Inventory':'Catalog'}}
                          </h2>
                        </p-header>

                        <!-- Replace default-state class with disabled-state -->
                        <div *ngFor="let privilege of catalogPrivilege; let pIndex = index"
                          class="default-state accordion-level-2">
                          <div class="user-permission-row">
                            <div class="user-permission-navition">
                              <i [ngClass]="privilege?.iconClass"></i>
                              <span>{{ privilege?.label }}</span>
                              <span>
                                <i class="fa fa-info-circle font-gray-35 ml-2" tooltipPosition="top"
                                  tooltipStyleClass="ticket-tooltip modifier pinned" [escape]="false"
                                  [pTooltip]="privilege?.title === 'manage-stock-adjustment' ? catalogStockAdjustmentTooltip : privilege?.title === 'update-inventory-PO' ? catalogInventoryPurchaseTooltip
                                  : privilege?.title === 'create-update-salescode' ? catalogCreateUpdateSalesCodeTooltip: catalogDataTooltip">
                                </i>
                              </span>
                            </div>

                            <div class="user-permission-status">
                              <app-switch-pill [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                                [disabled]="!privilege.configurable || !privilege.isVisible"
                                (appChange)="handlePrivilegeChange(privilege, $event)">
                              </app-switch-pill>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <!---- catalog privileges end-->

                  <!---- payment privileges -->
                  <div class="user-permission-row invoice-code-privilege" *ngIf="isPaymentDataPrivilgesEnabled || isSupportAdminAccount">
                    <p-accordion class="width-100p inner-accordion-wrapper"
                      styleClass="width-100p estimate-accordion reverse-chevron-icon"
                      expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-right">
                      <p-accordionTab>
                        <p-header>
                          <h2 class="mb-0 font-16 font-bold font-secondary-800">Payments</h2>
                        </p-header>

                        <!-- Replace default-state class with disabled-state -->
                        <div *ngFor="let privilege of paymentPrivilege; let pIndex = index"
                          class="default-state accordion-level-2">
                          <div class="user-permission-row">
                            <div class="user-permission-navition">
                              <i [ngClass]="privilege?.iconClass"></i>
                              <span>{{ privilege?.label }}</span>
                              <span *ngIf="privilege.title === 'change-payment-date'">
                                <i class="fa fa-info-circle font-gray-35 ml-2" tooltipPosition="top" [escape]="false"
                                  tooltipStyleClass="ticket-tooltip modifier pinned" [pTooltip]="paymentDataTooltip">
                                </i>
                              </span>
                            </div>

                            <div class="user-permission-status">
                              <app-switch-pill [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                                [disabled]="!privilege.isVisible && !isSupportAdminAccount"
                                (appChange)="handlePrivilegeChange(privilege, $event)">
                              </app-switch-pill>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <!---- payment privileges end-->

                  <!---- Royalty Fee Management exports privileges -->
                  <div class="user-permission-row invoice-code-privilege"
                    *ngIf="isRoyaltyReportEnabled && (isSupportAdminAccount || isRoyaltyPermissionPrivileged)">
                    <p-accordion class="width-100p inner-accordion-wrapper"
                      styleClass="width-100p estimate-accordion reverse-chevron-icon"
                      expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-right">
                      <p-accordionTab>
                        <p-header>
                          <h2 class="mb-0 font-16 font-bold font-secondary-800">Royalty</h2>
                        </p-header>

                        <!-- Replace default-state class with disabled-state -->
                        <div *ngFor="let privilege of royaltyPrivilege; let pIndex = index"
                          class="default-state accordion-level-2">
                          <div class="user-permission-row">
                            <div class="user-permission-navition">
                              <i [ngClass]="privilege?.iconClass"></i>
                              <span>{{ privilege?.label }}</span>
                              <span>
                                <i class="fa fa-info-circle font-gray-35 ml-2" tooltipPosition="top" [escape]="false"
                                  tooltipStyleClass="tooltip-royalty-permission  text-center"
                                  pTooltip="Users with this privilege can access Royalty Fees in General Settings to create and edit Royalty Fee percentages and designate the Sales Groups to which those royalties are applied">
                                </i>
                              </span>
                            </div>

                            <div class="user-permission-status">
                              <app-switch-pill [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                                (appChange)="handlePrivilegeChange(privilege, $event)">
                              </app-switch-pill>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <!---- Royalty Fee Management privileges end-->

                  <!---- account exports privileges -->
                  <div class="user-permission-row invoice-code-privilege"
                    *ngIf="adminRoles.includes(user?.role?.value) && isAccountingExportsEnabled">
                    <p-accordion class="width-100p inner-accordion-wrapper"
                      styleClass="width-100p estimate-accordion reverse-chevron-icon"
                      expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-right">
                      <p-accordionTab>
                        <p-header>
                          <h2 class="mb-0 font-16 font-bold font-secondary-800">Accounting</h2>
                        </p-header>

                        <!-- Replace default-state class with disabled-state -->
                        <div *ngFor="let privilege of accountingPrivilege; let pIndex = index"
                          class="default-state accordion-level-2">
                          <div class="user-permission-row">
                            <div class="user-permission-navition">
                              <i [ngClass]="privilege?.iconClass"></i>
                              <span>{{ privilege?.label }}</span>
                              <span *ngIf="privilege.title === 'change-payment-date'">
                                <i class="fa fa-info-circle font-gray-35 ml-2" tooltipPosition="top" [escape]="false"
                                  tooltipStyleClass="ticket-tooltip modifier pinned" [pTooltip]="paymentDataTooltip">
                                </i>
                              </span>
                            </div>

                            <div class="user-permission-status">
                              <app-switch-pill [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                                [disabled]="!privilege.isVisible"
                                (appChange)="handlePrivilegeChange(privilege, $event)">
                              </app-switch-pill>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <!---- account privileges end-->
                </div>
              </p-accordionTab>
            </p-accordion>

            <p-accordion styleClass="estimate-accordion reverse-chevron-icon" expandIcon="pi pi-fw pi-chevron-down"
              collapseIcon="pi pi-fw pi-chevron-right"
              *ngIf="isTechnicianSelected() && isTechSelfAssignUnassignService">
              <p-accordionTab>
                <p-header>
                  <h2 class="mb-0 font-16 font-bold font-secondary-800">Permissions</h2>
                </p-header>

                <!-- Replace default-state class with disabled-state -->
                <div class="default-state user-privilege">
                  <div *ngFor="let privilege of privileges; let pIndex = index">
                    <span
                      *ngIf="['gray-scale', 'assign-unassign-service','restrict-ip-access'].includes(privilege.title)"
                      class="user-permission-row" [ngClass]="{'flex-wrap':privilege?.title == 'restrict-ip-access'}">
                      <div class="ui-g-5">
                        <div class="user-permission-navition">
                          <i class="fal" [ngClass]="privilege.iconClass"></i>
                          <span *ngIf="privilege.title !== 'assign-unassign-service'">{{ privilege.label }}</span>
                          <span *ngIf="privilege.title === 'assign-unassign-service'">Self assignment</span>
                        </div>
                      </div>

                      <div class="ui-g-7"
                        [ngClass]="privilege.title !== 'assign-unassign-service' && 'flex-end-center'">
                        <div *ngIf="privilege.title !== 'assign-unassign-service'" class="user-permission-status">
                          <app-switch-pill [disabled]="!privilege.configurable"
                            [isActive]="selectedPrivilege[privilege?.title]?.permitted"
                            (appChange)="handlePrivilegeChange(privilege, $event)"></app-switch-pill>
                        </div>

                        <div *ngIf="privilege.title === 'assign-unassign-service'" class="user-permission-status">
                          <app-dropdown placeholder="" theme="border" class="width-100p" field="name"
                            styleClassSelectedView="p-6p" scrollHeight="198px" [options]="assignTechOptions"
                            [isDropdownIconVisible]="true" [fullyControlled]="true"
                            [value]="{ name: selectedPrivilege[privilege?.title]?.label }"
                            (appSelect)="onSelectSelfAssign($event, privilege)">
                          </app-dropdown>
                        </div>
                      </div>

                      <!-- ----- add restricted ips ------  -->
                      <ng-container
                        *ngIf="privilege?.title === 'restrict-ip-access' && selectedPrivilege[privilege?.title]?.permitted">
                        <ng-container *ngTemplateOutlet="restrictIpAccessTemplate"></ng-container>
                      </ng-container>
                      <!-- ----- add restricted ips ------  -->
                    </span>
                  </div>
                </div>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g p-0 mt-2 mb-4 pb-3">
    <div class="ui-g-8 p-0">
      <div class="ui-g-12 p-0">
        <!-- Start Multi-location -->
        <p *ngIf="user?.role?.value === userRoleConsts.admin && isMultiLocationEnabled && (isOnboarding || hasMultiLocationAccess)"
          class="mb-2 mt-4 pt-2 pb-1 font-bold font-16 b-bottom">
          Multi-location
        </p>

        <app-switch-pill
          *ngIf="user?.role?.value === userRoleConsts.admin && isMultiLocationEnabled && (isOnboarding || hasMultiLocationAccess)"
          position="end" label="Multi-location ownership" [isActive]="user?.hasMultiLocationAccess"
          (appChange)="handleChange('hasMultiLocationAccess', $event)">
        </app-switch-pill>

        <div *ngIf="isMultiLocationEnabled && hasMultiLocationAccess" class="location-accordion mt-4">
          <div class="user-container">
            <div class="user-accordion">
              <p-accordion styleClass="estimate-accordion reverse-chevron-icon" expandIcon="pi pi-fw pi-chevron-down"
                collapseIcon="pi pi-fw pi-chevron-right">
                <p-accordionTab [selected]="true">
                  <p-header>
                    <p class="mb-0 font-bold font-16 font-bold font-secondary-800">Multi Location Access</p>
                  </p-header>

                  <div class="default-state user-privilege">
                    <div class="user-permission-row" *ngFor="let shop of companyLocations">
                      <div class="col-md-8 user-permission-navition pl-0">
                        <i class="fal fa-map-marker-alt"></i>
                        <span>{{ shop?.name }}</span>
                      </div>

                      <div class="col-md-3 user-permission-navition">
                        <span *ngIf="shop?._id === user?.defaultShopId">Default</span>
                        <span *ngIf="shop?._id !== user?.defaultShopId" class="font-primary pointer"
                          [ngClass]="{ 'not-allowed': !shopAccesses.includes(shop?._id) }"
                          (click)="handleChange('defaultShopId', shop?._id)">Make default</span>
                      </div>

                      <div class="col-md-1 user-permission-status">
                        <app-switch-pill [fontSize]="14" [disabled]="!shop?.status || shop?._id === user?.defaultShopId"
                          [isActive]="shopAccesses.includes(shop?._id)"
                          (appChange)="handleShopAccessChange(shop?._id, $event)">
                        </app-switch-pill>
                      </div>
                    </div>
                  </div>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>
        <!-- End Multi-location -->
      </div>
    </div>
  </div>

  <div>
    <button *ngIf="userId && !isSupportUser && (isSupportAdminAccount || isAutoLeapUser)"
      class="btn btn-white btn-border btn-100 mr-2" (click)="changePassword()">
      {{ isAutoLeapUser ? 'Set Password' : 'Change Password' }}
    </button>
  </div>
  <!-- End User Create Form -->

  <!-- Start Actions -->
  <div class="create-user-footer flex-end-center mt-4 p-0 pl-8p pt-4 b-top-gray-85">
    <button class="btn btn-border btn-100 mr-2" (click)="handleDiscardChange()">Cancel</button>

    <button class="btn btn-primary btn-100" [disabled]="isCreatingUser || isCheckingForUniqueness"
      [ngClass]="{ 'not-allowed': !isCreatingUser }" (click)="handleSaveChange()">
      <span [ngClass]="{ 'pr-2': isCreatingUser }">
        {{ userId ? 'Save' : 'Create' }}
      </span>

      <i class="fal fa-spinner rotate" *ngIf="isCreatingUser"></i>
    </button>
  </div>
  <!-- End Actions -->
</div>


<ng-template #restrictIpAccessTemplate>
  <div class="w-100 my-3 d-flex flex-column">
    <div class="app-input-error">{{errors?.restrictIps}}</div>
    <div *ngIf="restrictedIps && restrictedIps.length">
      <div class="d-flex justify-content-between align-items-center " *ngFor="let item of restrictedIps;let i=index">
        <span class="flex-grow-1 my-3">
          <app-input id="add-ip-{{i}}" placeholder="Allowed IP Address*" styleClassLabel="left-0" styleClass="pl-0"
            styleClassInput="pl-0" [floatingLabel]="true" [isInvalid]="item.error" [value]="item.ip"
            [errorMessage]="item.error" (appFocus)="handleFocusIp(i)" (appBlur)="handleBlurIp(i)"
            (appChange)="handleIpChange(i, $event)"></app-input>
        </span>
        <button class="btn px-0" (click)="removeRestrictedIp(i)">
          <i class="fas fa-trash font-icon-red"></i>
        </button>
      </div>
    </div>

    <span *ngIf="restrictedIps.length < allowedIpsCount">
      <button class="btn btn-add px-0" (click)="addNewRestrictedIp()">
        <i class="fas fa-plus-circle"></i>
        Add IP Address</button>
    </span>
  </div>
</ng-template>
